<template>
  <div class>
    <drawer :title="addEditTitle" :dialogShow="addEditShow" @handleChange="back">
      <div slot="body" style="background:#dceaed;">
        <div class="pay-mains">
          <div class="member-msg">
            <div class="member-border">
              <el-avatar class="img" shape="circle" size="small" v-if="memberList.headImgUrl"
                :src="memberList.headImgUrl"></el-avatar>
              <el-avatar shape="circle" size="small" v-else :src="headerImg"></el-avatar>
              <div class="rows member-box" v-if="form.memberId">
                <p>{{ memberList.nickName }} {{ memberList.mobile ? memberList.mobile : memberList.idCardNo }}</p>
                <div class="flex-row mt5">
                  <p class="mobile">来源门店：{{ memberList.shopName }} </p>
                  <p>可用余额: <span class="fontSize18">￥{{ memberList.walletAmount }}</span></p>
                </div>
              </div>
              <div class="rows no-member" v-else>
                <p class="member-box">门店顾客</p>
              </div>
            </div>
          </div>
          <p class="order-title-boxs mtb24"><span class="blueBlock"></span><i>消费清单</i></p>
          <div class="totals-box plr16">
            <el-row class="order-details">
              <el-col :span="10" class="pl10">商品名称</el-col>
              <el-col :span="3" class="divCenter">单价(元)</el-col>
              <el-col :span="3" class="divCenter">数量</el-col>
              <el-col :span="4" class="divCenter">小计(元)</el-col>
              <el-col :span="4" class="tRight pr10">实付(元)</el-col>
            </el-row>
            <div class="order-scoll">
              <el-row v-for="(item, index) in parentForm.orderItemList" :key="index" class="mt20 order-good-detail">
                <el-col :span="10" class="pl10">{{ item.itemName }}</el-col>
                <el-col :span="3" class="color999 divCenter">{{ item.salePrice }}</el-col>
                <el-col :span="3" class="color999 divCenter">{{ item.itemNum }}</el-col>
                <el-col :span="4" class="color999 divCenter">{{ item.itemNum * item.salePrice }}</el-col>
                <el-col :span="4" class="tRight pr10">{{ item.realPayAmount }}</el-col>
                <el-col :span="3" class="pl10 mt20 color999">技师：</el-col>
                <el-col :span="21" class="mt20 pr10">
                  <div class="jishi">{{ item.staffNames }}</div>
                </el-col>
              </el-row>
            </div>
          </div>

          <el-row class="orderTotal borderT fontSize18">
            <el-col :span="12" class="flex-row pb24">
              <p class="label">消费数量：</p>
              <p class="num">{{ parentForm.itemNum }}</p>
            </el-col>
            <el-col :span="12" class="flex-row pb24">
              <p class="label">合计金额：</p>
              <p class="money num">￥{{ parentForm.orderAmount }}</p>
            </el-col>
            <el-col :span="12" class="flex-row">
              <p class="label">折扣优惠：</p>
              <span class="num moneys">￥{{ parentForm.discountAmount }}</span>
            </el-col>
            <el-col :span="12" class="flex-row pb24" v-if="form.memberId">
              <p class="label">卡券优惠：</p>
              <span v-if="isSelectCoupon || isFromPage" @click="couponSelect()" class="num moneys">¥ {{ couponAmount
              }}</span>
              <span v-else>
                <span class="shopClass" v-if="form.orderId">无</span>
                <span v-else @click="couponSelect()" class="shopClass">选择优惠券</span>
              </span>

            </el-col>
            <el-col :span="12" class="flex-row">
              <p class="label">实收金额：</p>
              <p class="moneys num fontSize20" v-if="!isNoEdit">
                ￥{{ (Number(parentForm.realPayAmount || 0) - Number(parentForm.couponAmount || 0)).toFixed(2) }}
              </p>
              <p class="moneys num fontSize20" v-else>
                ￥{{ parentForm.realPayAmount }}
              </p>
            </el-col>
          </el-row>
          <div class="pay-methods">
            <p class="order-title-boxs mtb24"><span class="blueBlock"></span><i>请选择收款方式</i></p>
            <div class="plr24 flex-row wraps">
              <div v-for="(item, index) in payWayList" :key="index" @click="payWayFun(item)"
                class="flex-row orderPayRadio" :class="[radio == item.payCode ? 'active' : '']">

                <div class="pay-img"><img :src="item.imgUrl" alt /></div>
                <div class="fontSize16">{{ item.payName }}</div>
                <div class="payCheak" v-if="radio == item.payCode"><img src="../../assets/images/new/payRadio.png" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="drawer-footer">
          <div class="btns">
            <el-button class="left-btn" @click="pendingOrder" v-if="!isPayWay">挂单</el-button>
            <el-button class="right-btn" @click="confirmMoney">收款￥{{
              isNoEdit ? parentForm.realPayAmount : Number((Number(parentForm.realPayAmount || 0) -
                Number(parentForm.couponAmount || 0)).toFixed(2)) }}</el-button>
          </div>
        </div>

      </div>
    </drawer>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" center="" style="margin-top: 20vh;">
      <span style="text-align: center;display: inline-block;width: 100%;">确定要挂单吗</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveMoney">确 定</el-button>
      </span>
    </el-dialog>
    <!-- ( -->
    <payDialog :hide="dialogHide" :oid='parentForm.id'
      :price="isNoEdit ? parentForm.realPayAmount : Number((Number(parentForm.realPayAmount) - Number(parentForm.couponAmount || 0)).toFixed(2))"
      :memberId="memberList.id" :mobile="memberList.mobile" :type="source" @changeDialog="savePay"></payDialog>
    <!-- @repay="refreshToken" -->
    <pay-form ref="payEditForm" @payFun="payMoney" :balance='balance' :source="sources" @rePay="refreshToken"
      :amount="isNoEdit ? parentForm.realPayAmount : Number((Number(parentForm.realPayAmount) - Number(parentForm.couponAmount || 0)).toFixed(2))"
      :meal="isMeal" :foot="foot"></pay-form>
    <quick-top-up ref="topUpForm" @handleChange="topUpPage" :isYuanJian="memberList.yuanjianTransferFlag"></quick-top-up>
    <member-top-up ref="memberTopUpForm" @memberChange="changeTopUp"></member-top-up>
    <confimDdialog ref="confimFrom" @handleChange="cashBack" :showTitle="source" :money="isNoEdit ? parentForm.realPayAmount : Number((Number(parentForm.realPayAmount) - Number(parentForm.couponAmount || 0)).toFixed(2))"
      :payWay="radio" :payWayDescription="this.form.payWayDescription"></confimDdialog>
    <yuan-jian-pay ref="yuanJianForm" @change="yuanJianChange"></yuan-jian-pay>
    <selectCoupon-set ref="selectCouponSetForm" @selectCouponChange="selectCouponChange"></selectCoupon-set>
  </div>
</template>

<script>
import minxin from "../../assets/javascript/minxin.js";
import payDialog from "../components/pay-dialog.vue";
import drawer from "../../components/common/drawer";
import memberTopUp from "../collectMoney/member/topUp";
import payForm from "./pay";
import confimDdialog from "../components/confim-dialog.vue";
import quickTopUp from "./quick-top-up.vue";
import YuanJianPay from './yuanJianPay.vue';
import selectCouponSet from "../collectMoney/productFootBath/selectCoupon.vue";
import { decrypt, encrypt } from "../../assets/javascript/untils";
import { Loading } from 'element-ui'
export default {
  mixins: [minxin],
  props: {
    sourceFrom: {
      type: String,
      default: null
    },
    foots: {
      type: Boolean,
      default: true
    },
    source: {
      type: String,
      default: null
    },
    sources: {
      type: String,
      default: null
    },
    isMeal: {
      type: String,
      default: null
    },

  },
  components: { payDialog, drawer, payForm, quickTopUp, memberTopUp, confimDdialog, YuanJianPay, selectCouponSet, },
  data() {
    return {
      radio: "cash",
      addEditShow: false,
      addEditTitle: "门店收银",
      dialogHide: false,
      pageHeight: this.$store.getters.MainHeight - 100 + "px",
      form: {
        orderId: "",
        payWay: "cash",
        payWayDescription: "现金",
        verifyCode: "",
        payCheckType: "",
        couponSendRecordId: '',
      },
      headerImg: require("../../assets/images/headerImg.png"),
      payWayList: [],
      parentForm: {
        memberId: "",
        couponAmount: 0,
      },
      dialogVisible: false,  // 挂单弹窗
      isPayWay: false,
      isPay: false,
      isYuanjianTakeIn: false,//远舰钱是否转入过来
      orderId: "",
      noMoneyStatus: false,
      oid: null,
      memberList: {},
      orderList: [],
      disable: false,
      count: 0,
      isSacn: false,
      isFromPage: false,
      isSelectCoupon: false,
      couponSendRecordId: '',
      couponAmount: 0,
      isNoEdit: false,
      balance: ''
    };
  },
  created() {
    this.init();
    this.foot = this.foots;
  },
  mounted() {
    this.doIt();
  },
  methods: {
    back() {
      if (this.isPayWay) {
        this.$confirm('未支付订单将在不久后自动关闭，请尽快支付~', {
          confirmButtonText: '暂时放弃',
          cancelButtonText: '继续支付',
          center: true
        }).then(() => {
          this.payWayList = [];

          this.addEditShow = false;
          this.$emit("change", true);
          localStorage.removeItem("payMobile")
          localStorage.setItem("orderId", this.form.orderId) // 套餐开卡   挂单页面使用
          this.isPayWay = false;
          this.isSelectCoupon = false;
          this.couponSendRecordId = '';
          this.parentForm.couponAmount = 0;
          this.couponAmount = 0;
          this.form.couponSendRecordId = '';
        }).catch(() => {

        });
      } else {
        this.payWayList = [];

        this.addEditShow = false;
        this.isSelectCoupon = false;
        this.couponSendRecordId = '';
        this.parentForm.couponAmount = 0;
        this.couponAmount = 0;
        this.form.couponSendRecordId = '';
      }
    },
    handleChangeDrawer() {
      this.addEditShow = false;
    },
    init() {
      this.$on("set", function (org) {
        this.addEditShow = true;
        sessionStorage.removeItem("payWay")
        this.isSacn = false;
        this.couponSendRecordId = '';
        this.couponAmount = 0
        this.isSelectCoupon = false;
        this.form = org;
        this.form.payWayDescription = org.payWayCn;
        this.balance = ''
        console.log('form值:', this.form);
        if (this.form.id) {
          this.parentForm = this.form;
          this.form.orderItemList = this.form.orderItemVOList;
          if (!this.form.orderId) {
            this.form.orderId = this.form.id;
          }
          this.isFromPage = true;
        }
        if (org.payFlag) {
          this.isPayWay = true;
        }
        if (this.form.couponAmount) {
          this.isNoEdit = true;
          this.isSelectCoupon = true;
          this.parentForm.couponAmount = this.form.couponAmount;
          this.couponAmount = this.form.couponAmount;
        }
        if (!this.form.payWayCn && !this.form.payWayImgUrl) {
          this.isMember();
        } else {
          this.radio = this.form.payWay;
          this.payWayList = [];
          let obj = {
            payCode: this.form.payWay,
            payName: this.form.payWayCn,
            imgUrl: this.form.payWayImgUrl,
          }
          this.payWayList.push(obj);
        }
        if (this.form.memberId) this.getMemberInfo();
      });
    },
    doIt() {
      //此处添加500毫秒延迟，目的是等待历史记录变化之后再添加空地址，使空地址能准确添加到栈顶，防止出错
      setTimeout(() => {
        if (!(history.state && history.state.target == "Final")) {
          window.history.pushState(
            { target: "MeanSure", random: Math.random() },
            "",
            location.href
          );
          window.history.pushState(
            { target: "Final", random: Math.random() },
            "",
            location.href
          );
        }
        window.addEventListener(
          "popstate",
          function (e) {
            if (e.state && e.state.target == "MeanSure") {
              //此处可调用一些自定义的操作，例如弹窗提示之类的，最后根据实际需要可调用上面三个函数中的任何一个，用于决定当前自定义操作完成之后，需要停留在本页面，还是回退，还是跳转到其他页面
              // this.doSomething();
              //alert('不支持回退');
              // stay(); //如此操作会停留在本页面
              history.forward();
              //back();如此操作会无副作用回退到上一级
              //toUrl（'http://www.baidu.com'）;如此操作会执行完之定义操作之后跳转到百度
            }
          },
          false
        );
      }, 500);
    },
    pendingOrder() {
      // 挂单弹窗
      if (this.isPayWay) return this.$message.error("已经开单，不可挂单");
      this.dialogVisible = true;
    },
    cashBack(val) {
      // 现金确定弹窗回调

      if (val) {
        this.form.payCode = val;
        if (!this.form.orderId) {
          this.form.orderId = this.form.id
        }
        // if (
        //   this.form.payWay == 'tonglianStore' ||
        //   this.form.payWay == 'yinlianStore'
        // ) {
        //   this.isSacn = true;
        //   console.log(2);
        //   let parmar = {
        //     orderId: this.form.orderId,
        //     payWay: this.form.payWay,
        //     queryFlag: false,
        //   }
        //   this.$refs['payEditForm'].$emit('set', parmar)
        // }

        console.log(this.form);
        if (!this.form.payWay) return this.$message.error("请选择支付方式")
        const loadingInstance = Loading.service({
          lock: true,
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$api.post(this.$url.order.pay, encrypt(JSON.stringify(this.form))).then(res => {
          if (res) {
            if (res && res.status == 'fail') {
              this.isPay = true;
              let parmar = {
                orderId: this.form.orderId,
                payWay: this.form.payWay,
                queryFlag: false,
                close: true,
                closeMessage: res.message
              }
              loadingInstance.close()
              this.$refs['payEditForm'].$emit('set', parmar);
              return
            }
            if (res) {
              loadingInstance.close()
              if (
                this.form.payWay == 'tonglianStore' ||
                this.form.payWay == 'yinlianStore'
              ) {
                this.isSacn = true;
                this.isPay = false;
                let parmar = {
                  orderId: this.form.orderId,
                  payWay: this.form.payWay,
                  queryFlag: true,
                }
                this.$refs['payEditForm'].$emit('set', parmar)
              } else {
                localStorage.removeItem("payMobile");
                localStorage.removeItem("productFootBathForm");
                this.$refs['payEditForm'].$emit('set', res);
              }
            }
          } else {
            loadingInstance.close()
          }
        })
      }
    },
    payWayFun(item) {
      this.dialogHide = false;
      this.form.payWay = item.payCode;
      this.form.payWayDescription = item.payName;
      this.radio = item.payCode;
    },
    getMemberInfo() {
      this.$api.get(this.$url.member.get, { id: this.form.memberId }).then(res => {
        if (res) {
          this.memberList = res;
          if (this.isYuanjianTakeIn) {
            this.confirmMoney();
          }
        }
      })
    },
    isMember() {
      let idFlag = ""
      if (this.form.memberId) {
        idFlag = true
      } else {
        idFlag = false
      }

      this.$api.get(this.$url.paywaySet.list, { isMember: idFlag, sourceFrom: this.sourceFrom ? this.sourceFrom : "card" })
        .then(res => {
          if (res) {
            this.payWayList = res;
            for (let i in this.payWayList) {
              if (i == 0) {
                this.form.payWay = this.payWayList[i].payCode;
                this.radio = this.payWayList[i].payCode;
                this.$set(this.payWayList[i], "show", true);
              } else {
                this.$set(this.payWayList[i], "show", false);
              }
            }

            if (this.form.memberId && (this.source == "openCard" || this.source == "groupType")) {
              // 折扣
              this.discount(this.$url.order.discountCalculate)
            }
          }
        });
    },
    discount(url) {
      //. 折扣
      if (!this.form.payWay) return this.$message.error("请选择支付方式")
      this.$api.post(url, this.form).then(res => {
        if (res) {
          this.parentForm = res;
          console.log(this.couponAmount, 'couponAmount');
          if (JSON.parse(localStorage.getItem("payMobile")) && JSON.parse(localStorage.getItem("payMobile")).res && JSON.parse(localStorage.getItem("payMobile")).res.couponAmount) {
            this.parentForm.couponAmount = JSON.parse(localStorage.getItem("payMobile")).res.couponAmount;
          } else if (this.couponAmount) {
            this.parentForm.couponAmount = this.couponAmount;
            console.log(this.parentForm.couponAmount, 'this.parentForm.couponAmount');
          }
        }
      }).catch(error => { });
    },
    createOrder(url) {
      // 公共方法
      if (!this.form.payWay) return this.$message.error("请选择支付方式")
      this.$api.post(url, encrypt(JSON.stringify(this.form))).then(res => {
        if (res) {
          return res
        }
      }).catch(error => { });
    },
    getToken() {
      this.$api.get(this.$url.order.getToken).then(res => {
        if (res) {
          this.form.repeatToken = res;
        }
      })
    },
    saveMoney() {
      if (this.source == 'openCard') {
        this.form.couponSendRecordId = this.couponSendRecordId;
        this.form.millisecond = new Date().getTime();
        this.$api.post(this.$url.order.createCard, encrypt(JSON.stringify(this.form))).then(res => {
          if (res.constructor !== Object) {
            if (!res) return this.getToken();
            this.dialogVisible = false;
            this.addEditShow = false;
            this.$message.success("挂单成功");
            this.isPayWay = false;
            this.form = {};
            this.$emit("change", true)
          } else {
            if (res.status == 'accountAmountInsufficient') {
              localStorage.setItem(
                "payMobile",
                JSON.stringify({
                  id: this.parentForm.id,
                  mobile: this.memberList.mobile ? this.memberList.mobile : this.memberList.idCardNo,
                  path: this.$route.path,
                  res: this.parentForm
                })
              );
              this.$refs["topUpForm"].$emit("set", "0");
            }
            this.$api.get(this.$url.order.getToken).then(res => {
              if (res) {
                this.form.repeatToken = res;
              }
            })
          }
        }).catch(error => { });
      }
    },
    payMoney(org) {
      console.log(org, "paysuccess")
      if (org) {
        this.addEditShow = false;
        this.$emit("change", true);
        //支付完成时充值付款方式标识
        this.isPayWay = false;
        this.isSelectCoupon=false
        this.isFromPage=false
        // addEditShow
      }
    },
    topUpPage(org) {
      if (org && org != 'yuanjian') {
        this.$refs["memberTopUpForm"].$emit("set", this.memberList.id);
      } else if (org && org == 'yuanjian') {
        // yuanjianTransferFlag: true
        // this.memberList.payPrice = (Number(this.parentForm.realPayAmount) - Number(this.parentForm.couponAmount || 0)).toFixed(2);
        // this.$refs["yuanJianForm"].$emit("set", this.memberList);
        let obj = {
          payPrice: (Number(this.parentForm.realPayAmount) - Number(this.parentForm.couponAmount || 0)).toFixed(2),
          memberId: this.memberList.id,
          type: this.source
        }
        this.$refs['yuanJianForm'].$emit('set', obj);
      }
    },
    changeTopUp(org) {
      if (org) {
        this.getMemberInfo();
        if (this.form.memberId && this.source == "openCard") {
          // 折扣
          console.log('进来了');
          this.discount(this.$url.order.discountCalculate)
        }
      }
    },
    getToken() {
      this.$api.get(this.$url.order.getToken).then(res => {
        if (res) {
          this.form.repeatToken = res;
        }
      })
    },
    confirmMoney() {
      
      if (this.isSacn) return
      if (this.form.payWay == "wallet") {
        let orderType = '';
        if (this.form.sourceFrom == 'card') {
          orderType = 'card';
        } else {
          orderType = this.source;
        }
        this.$api
          .post(this.$url.repairDocument.checkMemberAccountAmount, {
            memberId: this.memberList.id,
            payWay: this.form.payWay,
            realPayAmount: (
              Number(this.parentForm.realPayAmount || 0) -
              Number(this.parentForm.couponAmount || 0)
            ).toFixed(2),
            // orderType: this.source,
            orderType: orderType,
          })
          .then((res) => {
            if (res.constructor !== Object) {
              if (!res) return;
              this.trueConfirmMoney();
            } else {
              if (res.status == "accountAmountInsufficient") {
                localStorage.setItem(
                  "payMobile",
                  JSON.stringify({
                    id: this.form.id,
                    mobile: this.memberList.mobile
                      ? this.memberList.mobile
                      : this.memberList.idCardNo,
                    path: this.$route.path,
                    res: this.listSelected,
                  })
                );
                this.$refs["topUpForm"].$emit("set", "0");
              }
            }
          })
          .catch((error) => { });
      } else {
        this.trueConfirmMoney();
      }
      
    },
    trueConfirmMoney() {
      if (this.form.payWay == "wallet") {
        if (this.memberList && this.memberList.walletAmount < (this.isNoEdit ? this.parentForm.realPayAmount : (Number(this.parentForm.realPayAmount) - Number(this.parentForm.couponAmount || 0)).toFixed(2))) {
          localStorage.setItem(
            "payMobile",
            JSON.stringify({
              id: this.parentForm.id,
              mobile: this.memberList.mobile ? this.memberList.mobile : this.memberList.idCardNo,
              path: this.$route.path,
              res: this.parentForm
            })
          );
          this.$refs["topUpForm"].$emit("set", "0");
        } else {
          if (this.isPayWay) return this.dialogHide = true;

          if (this.source == 'openCard') {
            this.form.couponSendRecordId = this.couponSendRecordId;
            this.form.millisecond = new Date().getTime();
            this.$api.post(this.$url.order.createCard, encrypt(JSON.stringify(this.form))).then(res => {
              if (res.constructor !== Object) {
                if (!res) return this.getToken();
                this.form.orderId = res;
                localStorage.setItem("payWay", JSON.stringify(this.parentForm))
                this.dialogHide = true;
                this.isPayWay = true;
                this.isPay = true;
                let a = [];
                this.payWayList.map(item => {
                  if (item.payCode == this.form.payWay) {
                    a.push(item)
                  }
                })
                this.payWayList = a;
              } else {
                if (res.status == 'accountAmountInsufficient') {
                  localStorage.setItem(
                    "payMobile",
                    JSON.stringify({
                      id: this.parentForm.id,
                      mobile: this.memberList.mobile ? this.memberList.mobile : this.memberList.idCardNo,
                      path: this.$route.path,
                      res: this.parentForm
                    })
                  );
                  this.$refs["topUpForm"].$emit("set", "0");
                }
                this.$api.get(this.$url.order.getToken).then(res => {
                  if (res) {
                    this.form.repeatToken = res;
                  }
                })
              }
            })
          } else {
            localStorage.setItem("payWay", JSON.stringify(this.parentForm))
            this.dialogHide = true;
            this.isPayWay = true;
          }

        }
      } else {
        // 现金收款
        if (this.isPayWay) return this.$refs["confimFrom"].$emit("set", true);
        if (this.source == 'openCard') {
          this.form.couponSendRecordId = this.couponSendRecordId;
          this.form.millisecond = new Date().getTime();
          this.$api.post(this.$url.order.createCard, encrypt(JSON.stringify(this.form))).then(res => {
            console.log(res);
            if (res.constructor !== Object) {
              if (!res) return this.getToken();
              this.form.orderId = res;
              this.$refs["confimFrom"].$emit("set", true);
              localStorage.setItem("payWay", JSON.stringify(this.parentForm))
              this.isPayWay = true;
              this.isPay = true;
              let a = [];
              this.payWayList.map(item => {
                if (item.payCode == this.form.payWay) {
                  a.push(item)
                }
              })
              this.payWayList = a;
            } else {
              if (res.status == 'accountAmountInsufficient') {
                localStorage.setItem(
                  "payMobile",
                  JSON.stringify({
                    id: this.parentForm.id,
                    mobile: this.memberList.mobile ? this.memberList.mobile : this.memberList.idCardNo,
                    path: this.$route.path,
                    res: this.parentForm
                  })
                );
                this.$refs["topUpForm"].$emit("set", "0");
              }
              this.$api.get(this.$url.order.getToken).then(res => {
                if (res) {
                  this.form.repeatToken = res;
                }
              })
            }
          })
        } else {
          this.$refs["confimFrom"].$emit("set", true);
        }
      }
    },
    savePay(org) {
      if (org != "") {
        this.form.payCheckType = org.payCheckType;
        this.form.verifyCode = org.verifyCode;
        if (this.source != 'openCard') {
          this.form.orderId = this.form.id;
        }
        this.form.couponSendRecordId = this.couponSendRecordId;
        const loadingInstance = Loading.service({
          lock: true,
          background: 'rgba(0, 0, 0, 0.7)'
        });
        if (this.source == 'openCard') { // 产品泡脚 - 卡项  走新版支付 
          if (!this.form.payWay) return this.$message.error("请选择支付方式")
          this.$api.post(this.$url.order.pay, encrypt(JSON.stringify(this.form))).then(res => {
            if (res && res.constructor != Object) {
              this.dialogHide = false;
              this.isPayWay = false;
              console.log(this.sources);
              if (this.form.payWay == 'wallet') {
                let a = Number(this.memberList.walletAmount)
                let b = Number(this.parentForm.realPayAmount)
                let c = Number(this.parentForm.couponAmount || 0)
                if (this.sources) {
                  console.log(1);
                  this.balance = (a - b).toFixed(2);
                } else {
                  console.log(2);
                  this.balance = (a - b + c).toFixed(2);
                }
              }
              this.orderId = res;
              loadingInstance.close()
              localStorage.removeItem("payMobile");
              this.$refs["payEditForm"].$emit("set", res);
            } else {
              // this.$notify({
              //   title: '提示',
              //   message: res.message || '未知异常',
              // })
              loadingInstance.close()
            }
          }).catch(error => { });
        } else {
          if (!this.form.payWay) return this.$message.error("请选择支付方式")
          this.$api.post(this.$url.order.pay, encrypt(JSON.stringify(this.form))).then(res => {
            if (res && res.constructor != Object) {
              this.dialogHide = false;
              this.isPayWay = false;
              if (this.form.payWay == 'wallet') {
                let a = Number(this.memberList.walletAmount)
                let b = Number(this.parentForm.realPayAmount)
                let c = Number(this.parentForm.couponAmount || 0)
                if (this.sources) {
                  this.balance = (a - b).toFixed(2);
                } else {
                  this.balance = (a - b - c).toFixed(2);
                }
              }
              this.orderId = res;
              loadingInstance.close()
              localStorage.removeItem("payMobile");
              this.$refs["payEditForm"].$emit("set", res);
            } else {
              // this.$notify({
              //   title: '提示',
              //   message: res.message || '未知异常',
              // })
              loadingInstance.close()
            }
          })
            .catch(error => { });
        }

      } else {
        this.dialogHide = false;
      }
    },
    yuanJianChange(org) {
      if (org) {
        this.isYuanjianTakeIn = true;
        this.getMemberInfo();
      }
    },
    payChange() {
      console.log("payChange");
    },
    refreshToken() {
      this.isSacn = false;
      this.$api.get(this.$url.order.getToken).then((res) => {
        if (res) {
          this.form.repeatToken = res;
        }
      })
    },

    couponSelect() {
      if (this.isNoEdit) {
        return;
      }
      if (this.form.orderId) {
        return;
      }
      let a = [];
      this.parentForm.orderItemList.map((item) => {
        let dic = { "itemId": item.itemId, "realPayAmount": item.realPayAmount }
        a.push(dic)
      })
      this.$refs['selectCouponSetForm'].$emit('set', {
        memberId: this.form.memberId,
        realPayAmount: this.parentForm.realPayAmount,
        orderItemList: a,
        couponSendRecordId: this.couponSendRecordId,
      })
    },
    selectCouponChange(org) {
      console.log(org);
      if (org.id) {
        this.isSelectCoupon = true;
        this.couponSendRecordId = org.id;
        this.parentForm.couponAmount = org.couponAmount;
        this.form.couponSendRecordId = org.id;
        this.couponAmount = org.couponAmount;
      } else {
        this.isSelectCoupon = false;
        this.couponSendRecordId = '';
        this.parentForm.couponAmount = 0;
        this.form.couponSendRecordId = '';
        this.couponAmount = 0;
      }
    },
  }
};
</script>
<style>
.payway-success .el-button+.el-button {
  margin-left: 0;
}
</style>
<style scoped lang="less">
@import "../../assets/css/edit.less";

.pay-mains {
  background: #fff;
  box-sizing: border-box;

  .titles-head {
    border-top: 0;
  }

  .member-msg {
    padding: 16px 16px 0;

    .member-border {
      width: 100%;
      background-size: 100% 100%;
      color: white;
      display: flex;
      align-items: center;
      border-radius: 10px;
      padding: 12px 15px;
      background: #3388ff;
      box-sizing: border-box;

      .member-box {
        margin-left: 10px;

        .mobile {
          line-height: 1.6;
          margin-right: 10px;
        }
      }
    }
  }
}

.order-details {
  height: 56px;
  line-height: 56px;
  background: #F7F8FA;
}

.order-scoll {
  height: calc(100vh - 670px);
  overflow-y: auto;

  .order-good-detail {
    padding-bottom: 20px;
    border-bottom: 1px solid #EBEDF0;
  }
}

.orderTotal {
  padding: 23px 25px 0;
}

.pay-methods {

  border-top: 10px solid #F5F5F5;
  margin-top: 20px;

  .orderPayRadio {
    box-sizing: border-box;
    width: 32%;
    height: 56px;
    background: #FFFFFF;
    border: 1px solid #DCDEE0;
    border-radius: 4px;
    align-items: center;
    padding-left: 16px;
    cursor: pointer;
    position: relative;
    margin-right: 2%;
    margin-bottom: 10px;

    &:nth-of-type(3n) {
      margin-right: 0 !important;
    }

    .payCheak {
      width: 30px;
      height: 30px;
      position: absolute;
      top: 0;
      right: 0;
    }

    .pay-img {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }

    img {
      width: 100%;
      height: 100%;
    }
  }

  .active {
    color: #3388FF;
    border: 1px solid #3388FF;
    background: #EAF4FE;
  }
}

.btns {
  width: 100%;
  display: flex;
  padding: 10px 24px 10px;
  border-top: 1px solid #EEE;

  .left-btn {
    width: 176px;
    height: 56px;
    color: #fff;
    font-size: 20px;
    background: #535A6C;
    border-radius: 4px;
  }

  .right-btn {
    flex: 1;
    width: 100%;
    color: #fff;
    font-size: 20px;
    height: 56px;
    background: #FF5449;
    border-radius: 4px;
  }
}</style>
